(() => {
  if (window.BDCartDiscounts) return;
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  const request = async (path, data) => {
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(data ? { body: JSON.stringify(data) } : { cache: 'no-store' })
    });
    const result = await response.json();
    if (!response.ok) throw new Error('Unable to update cart');
    return result;
  };
  const codesFrom = cart => [...new Set([
    ...(cart.discount_codes || []).filter(code => code.applicable !== false).map(code => code.code),
    ...(cart.cart_level_discount_applications || []).filter(discount => discount.type === 'discount_code').map(discount => discount.title),
    ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application).filter(discount => discount?.type === 'discount_code').map(discount => discount.title))
  ].filter(Boolean))];
  const identity = item => JSON.stringify([Number(item.variant_id || item.id), Object.entries(item.properties || {}).sort(), item.selling_plan_allocation?.selling_plan?.id || null]);
  const applied = (cart, code) => (cart.items || []).some(item => (item.line_level_discount_allocations || []).some(allocation => allocation.amount > 0 && allocation.discount_application?.title?.toUpperCase() === code.toUpperCase())) || (cart.cart_level_discount_applications || []).some(discount => discount.total_allocated_amount > 0 && discount.title?.toUpperCase() === code.toUpperCase());
  window.BDCartDiscounts = {
    async addBundle(items, code, cartUrl) {
      if (busy) throw new Error('Another cart update is in progress');
      busy = true;
      let before;
      let addStarted = false;
      let previousCodes = [];
      try {
        before = await request('cart.js');
        previousCodes = codesFrom(before);
        addStarted = true;
        await request('cart/add.js', { items });
        const codes = [...new Set([...previousCodes, code])];
        const after = await request('cart/update.js', { discount: codes.join(',') });
        if (!applied(after, code) || previousCodes.some(previous => !applied(after, previous))) throw new Error('Bundle discount was not applied');
        const confirmed = await request('cart.js');
        if (!applied(confirmed, code)) throw new Error('Bundle discount could not be confirmed');
        window.location.assign(cartUrl);
      } catch (error) {
        if (addStarted && before) {
          try {
            const current = await request('cart.js');
            const updates = {};
            for (const item of current.items || []) {
              if (!items.some(added => identity(added) === identity(item))) continue;
              const original = before.items.find(previous => identity(previous) === identity(item));
              updates[item.key] = original?.quantity || 0;
            }
            await request('cart/update.js', { updates, discount: previousCodes.join(',') });
          } catch (rollbackError) {
            window.location.assign(cartUrl);
          }
        }
        throw error;
      } finally {
        busy = false;
      }
    }
  };
})();
